import React, { useState } from 'react';

import {
    TranslatedString,
    Card,
} from '@bosch/bt-ui';

import './PathfinderHelper.css';
import withErrorHandler from '../../../components/ErrorHandler';
import PathfinderUpdate from './PathfinderUpdate';
import PathfinderInfo from './PathfinderInfo';
import RestfulCallLoading from '../../../components/RestfulCallLoading';

const PathfinderHelper = (props) => {
    const {
        token,
        isLoggedIn,
        setPathfinderUpdateStatus,
        pathfinderInfoExternalResult,
        setPathfinderInfoExternalResult,
        pathfinderInfoStatus,
        getPathfinderInfo
    } = props;

    const [searchPhysicalPanelId, setSearchPhysicalPanelId] = useState('');
    const [physicalPanelIdErrorMsg, setPhysicalPanelIdErrorMsg] = React.useState("")

    return (
        <Card
            htmlAttributes={{
                id: 'pathfinder-helper',
            }}
        >
            <div className="caption font-large"><TranslatedString stringId="caption-pathfinder-helper" /></div>
            <div className='pathfinder-helper'>
                <PathfinderUpdate token={token}
                    isLoggedIn={isLoggedIn}
                    searchPhysicalPanelId={searchPhysicalPanelId}
                    setSearchPhysicalPanelId={setSearchPhysicalPanelId}
                    physicalPanelIdErrorMsg={physicalPanelIdErrorMsg}
                    setPhysicalPanelIdErrorMsg={setPhysicalPanelIdErrorMsg}
                    setPathfinderUpdateStatus={setPathfinderUpdateStatus}
                    setPathfinderInfoExternalResult={setPathfinderInfoExternalResult}
                />
                <PathfinderInfo token={token}
                    isLoggedIn={isLoggedIn}
                    searchPhysicalPanelId={searchPhysicalPanelId}
                    physicalPanelIdErrorMsg={physicalPanelIdErrorMsg}
                    pathfinderInfoStatus={pathfinderInfoStatus}
                    setPathfinderUpdateStatus={setPathfinderUpdateStatus}
                    pathfinderInfoExternalResult={pathfinderInfoExternalResult}
                    getPathfinderInfo={getPathfinderInfo}
                />
            </div>
            <RestfulCallLoading status={pathfinderInfoStatus} />
        </Card>
    );
};

export default withErrorHandler(React.memo(PathfinderHelper));